import { Box, Button, Dialog, Typography } from '@mui/material';

import React from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
import { IconWrapper } from '../../elements/IconWrapper/Index';

interface IProps {
  iconName: string;
  popupText: string;
  popupTextColor?: string;
  splitText?: string;
  splitTextColor?: string;
  yesText?: string;
  noText?: string;
  open: boolean;
  handleClose?: () => void;
  yesClickHandler: (ev?: React.MouseEvent) => void;
  noClickHandler: (ev?: React.MouseEvent) => void;
  fontSmall?: boolean;
  customComponent?: React.ReactNode;
  buttonVariant?: 'default' | 'greenContained';
  closeIcon?: boolean;
  disableEllipsis?: boolean;
}
const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(206) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(206) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: '30%',
    transform: 'translateY(-50%)',
  },
  actionPopupText: {
    margin: {
      xs: '30% auto 20px auto',
      md: `auto auto ${pxTovW(20)} auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: 'max-content',
    width: { xs: '90%', md: pxTovW(388) },
  },
  actionPopupTextSmall: {
    margin: {
      xs: `${pxToRem(60)} auto 0 auto`,
      md: `${pxTovW(110)} auto 0 auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: '100%',
    width: { xs: '90%', md: pxTovW(388) },
  },
  customComponentBox: {
    margin: {
      xs: `${pxToRem(50)} auto 0 auto`,
      md: `${pxTovW(90)} auto 0 auto`,
    },
    textAlign: 'center',
    height: '100%',
    width: { xs: '90%', md: '100%' },
  },
};

export const ActionsPopup = (props: IProps) => {
  const {
    open,
    iconName,
    popupText,
    popupTextColor,
    splitText,
    splitTextColor,
    yesText,
    noText,
    handleClose,
    yesClickHandler,
    noClickHandler,
    fontSmall,
    customComponent,
    buttonVariant,
    closeIcon,
    disableEllipsis,
  } = props;
  return (
    <Dialog open={open} onClose={handleClose && handleClose}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          // alignItems: 'center',
          // height: '100vh',
          // width: '100vw',
        }}
      >
        <Box
          sx={{
            height: customComponent
              ? 'max-content'
              : { xs: pxToRem(235), md: pxTovW(528), lg: pxTovW(428) },
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            width: { xs: pxToRem(295), md: pxTovW(537) },
            borderRadius: '10%',
            position: 'fixed',
            top: '30%',
            // left: { xs: '10%', sm: '16%', md: '30%' },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              top: '0px',
              left: '0%',
              height: pxTovW(8),
              width: '100%',
            }}
          >
            <IconBox iconName={iconName} />
          </Box>
          {customComponent ? (
            <Box sx={styles.customComponentBox}>{customComponent}</Box>
          ) : (
            <Box
              sx={
                fontSmall ? styles.actionPopupTextSmall : styles.actionPopupText
              }
            >
              {!splitText ? (
                popupText.length ? (
                  <Typography
                    variant={fontSmall ? 'h2' : 'h1'}
                    fontWeight="regular"
                    fontFamily="Lato"
                    sx={
                      disableEllipsis
                        ? {}
                        : {
                            display: '-webkit-box',
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                          }
                    }
                    color={popupTextColor ? popupTextColor : 'initial'}
                  >
                    {popupText}
                  </Typography>
                ) : null
              ) : (
                <Box
                  sx={{
                    width: '106%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: pxToRem(15), md: pxTovW(30) },
                  }}
                >
                  <Typography
                    variant={fontSmall ? 'h2' : 'h1'}
                    fontWeight={'regular'}
                    fontFamily="Lato"
                    color={popupTextColor ? popupTextColor : 'initial'}
                  >
                    {popupText}
                  </Typography>
                  <Typography
                    variant={fontSmall ? 'h2' : 'h1'}
                    fontFamily={fontSmall ? 'Lato' : 'Poppins'}
                    // fontFamily={'Poppins'}
                    color={splitTextColor ? splitTextColor : 'initial'}
                  >
                    {splitText}
                  </Typography>
                </Box>
              )}
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: { xs: pxToRem(13), md: pxTovW(25) },
              marginBottom: '29px',
              marginTop: { xs: pxToRem(20), md: pxTovW(25) },
            }}
          >
            <Button
              variant="outlined"
              sx={{
                height: customComponent
                  ? 'max-content'
                  : { xs: pxToRem(48), md: pxTovW(88) },
                width: { xs: pxToRem(120), md: pxTovW(218) },
                minHeight: customComponent
                  ? { xs: pxToRem(55), md: pxTovW(88) }
                  : 'auto',
                backgroundColor:
                  buttonVariant === 'greenContained'
                    ? 'rgba(10, 163, 79, 1)'
                    : 'rgba(193, 248, 218, 1)',
                border: '1px solid rgba(10, 242, 116, 1)',
                borderRadius: '10px',
                '&:hover': {
                  backgroundColor:
                    buttonVariant === 'greenContained'
                      ? 'rgba(10, 163, 79, 1)'
                      : 'rgba(193, 248, 218, 1)',
                },
              }}
              onClick={yesClickHandler}
            >
              {buttonVariant === 'greenContained' ? (
                <Typography variant="h3" color="white" fontWeight={900}>
                  {yesText ? yesText : 'Yes'}
                </Typography>
              ) : (
                <Typography variant="h2" fontFamily="Lato">
                  {yesText ? yesText : 'Yes'}
                </Typography>
              )}
            </Button>
            <Button
              variant="outlined"
              sx={{
                height: customComponent
                  ? 'max-content'
                  : { xs: pxToRem(48), md: pxTovW(88) },
                minHeight: customComponent
                  ? { xs: pxToRem(55), md: pxTovW(88) }
                  : 'auto',
                width: { xs: pxToRem(120), md: pxTovW(218) },
                backgroundColor:
                  buttonVariant === 'greenContained'
                    ? 'rgba(96, 249, 166, 1)'
                    : 'rgba(255, 238, 238, 1)',
                border: '1px solid rgba(255, 168, 168, 1)',
                borderRadius: '10px',
                '&:hover': {
                  backgroundColor:
                    buttonVariant === 'greenContained'
                      ? 'rgba(96, 249, 166, 1)'
                      : 'rgba(255, 238, 238, 1)',
                },
              }}
              onClick={noClickHandler}
            >
              {buttonVariant === 'greenContained' ? (
                <Typography variant="h3" fontFamily="poppins" fontWeight={100}>
                  {noText ? noText : 'No'}
                </Typography>
              ) : (
                <Typography variant="h2">{noText ? noText : 'No'}</Typography>
              )}
            </Button>
          </Box>
          {closeIcon && (
            <Button onClick={handleClose} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                  position: 'fixed',
                  top: { xs: '15%', md: '30%' },
                  left: { md: '65%' },
                }}
              />
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};
interface IConProps {
  iconName: string;
}
const IconBox = (props: IConProps) => {
  const { iconName } = props;
  return (
    <Box sx={styles.iconBox}>
      <ImageWrapper
        name={iconName}
        parentFolder="icons"
        type="png"
        styles={{
          height: { xs: pxToRem(52), md: pxTovW(94) },
          width: { xs: pxToRem(52), md: pxTovW(94) },
        }}
      />
    </Box>
  );
};
